<div
  class="flex flex-col-reverse rounded-md bg-blue-10 sm:flex-row print:items-center print:bg-transparent"
  [style.min-height.px]="config?.height ?? 400"
>
  <div class="flex grow flex-col items-center justify-center py-6">
    <ng-content />
  </div>
  <a [routerLink]="mapClickUrl" [queryParams]="{ mapType }" rel="nofollow">
    @if (markers) {
      <rma-static-google-map
        [markers]="markers"
        [config]="config"
        [class.cursor-pointer]="config?.clickToInteractive"
        [staticMapUrl]="staticMapUrl"
      />
    }
  </a>
</div>
